"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefColVisitor = void 0;
const visitor_base_1 = require("./visitor.base");
class RefColVisitor extends visitor_base_1.VisitorBase {
    referencedColumns;
    planColumns;
    constructor() {
        super();
        this.referencedColumns = [];
        this.planColumns = [];
    }
    visitColumn(node) {
        if (node.abstractText.includes('plan.')) {
            this.planColumns.push(node.abstractText.split('.')[1]);
            return;
        }
        this.referencedColumns.push(node.abstractText);
    }
}
exports.RefColVisitor = RefColVisitor;
